module.exports = __webpack_public_path__ + "media/images/gift_plan/gift-8cd624927b3fa09eb671251c2c629659.png";